import {
	algoliaInsightsPayload,
	sendAlgoliaInsightEventsProps,
} from './sendAlgoliaInsightEvents.types'

export const sendAlgoliaInsightEvents = ({
	eventType,
	eventName,
	track,
	indexName = `${process.env.NEXT_PUBLIC_ALGOLIA_INDEX}`,
}: sendAlgoliaInsightEventsProps): void => {
	// Early return if Algolia analytics is not available
	if (!window.aa) {
		return
	}

	// Create base payload
	const payload: algoliaInsightsPayload = {
		index: indexName,
		eventName,
		objectIDs: [],
	}
	// For search results, use track data with position and query info
	const { objectID, __position, __queryID, id } = track

	// Check if we have complete search context (position, queryID, objectID)
	const hasSearchContext =
		__position !== undefined &&
		__queryID !== undefined &&
		objectID !== undefined

	// Handle different event types
	if (eventType === 'clickedObjectIDsAfterSearch' && hasSearchContext) {
		payload.objectIDs = [objectID]
		payload.positions = [__position]
		payload.queryID = __queryID
	} else if (
		eventType === 'convertedObjectIDsAfterSearch' &&
		hasSearchContext
	) {
		payload.objectIDs = [objectID]
		payload.queryID = __queryID
	} else {
		// Fallback to track ID if search context is missing
		payload.objectIDs = [id.toString()]
	}

	// Send the event to Algolia
	window.aa(eventType, payload)
}
